
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';
import { AnalysisRequest } from '@/modules/analysis/models/analysisRequest';
import ArchiveRequestForm from '@/modules/analysis/components/ArchiveRequestForm.vue';

@Component({
  components: { ArchiveRequestForm }
})
export default class AnalysisDashboardList extends Vue {
  @Prop({ required: true })
  protected value!: AnalysisRequest;
  protected menuArchive?: boolean = false;

  protected get statusColorClass(): string {
    let status = this.value.currentStatus;

    if (status == RequestStatusEnum.OPENED) {
      return 'status-warning';
    } else if (status == RequestStatusEnum.IN_PROGRESS) {
      return 'status-info';
    } else if (status == RequestStatusEnum.AWAITING_VALIDATION) {
      return 'status-awaitingValidation';
    } else if (status == RequestStatusEnum.FINISHED) {
      return 'status-success';
    } else if (status == RequestStatusEnum.ARCHIVED) {
      return 'status-archive';
    }
    return 'status-unknown';
  }

  protected get dueDateColorClass(): string {
    try {
      const remainingDays = this.daysRemaining(this.value.subject.resSubmissionDate);
      if (remainingDays < 7) {
        return 'error--text';
      } else if (remainingDays >= 7 && remainingDays <= 30) {
        return 'warning--text';
      } else {
        return 'success--text';
      }
    } catch (error) {
      return '';
    }
  }

  protected get isArchive(): boolean {
    return this.value.currentStatus === RequestStatusEnum.ARCHIVED;
  }

  private daysRemaining(dateStr: string): number {
    const currentDate = new Date();
    const dueDate = new Date(dateStr);
    if (isNaN(dueDate.getTime())) {
      throw new Error("Invalid date. Make sure the date is in ISO format (e.g., '2023-11-30T00:00:00.000Z').");
    }
    const millisecondsDifference = dueDate.getTime() - currentDate.getTime();
    const daysRemaining = Math.ceil(millisecondsDifference / (1000 * 60 * 60 * 24));
    return daysRemaining;
  }
}
